import request from "http/request";
import endpointMaker from "appredux/endpoints";
import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getShowDataFromLocalStorage,
  getShowsFromLocalStorage,
  getShowListFromLocalStorage,
  getUserInfoFromLocalStorage,
  getEventPassDataByShowFromLocalStorage,
} from "appredux/utils";
import moment from "moment";
import { userService } from "api/user";

const getFilterByShowEndDate = async () => {
  const queryParams = new URLSearchParams(window.location.search);
  const isInternalUser = await userService.isInternalUser(localStorage.getItem("email"));
  let filterByShowEndDate = moment().subtract(1, "days").format("YYYY-MM-DD");

  if (isInternalUser) {
    filterByShowEndDate = moment().subtract(12, "months").format("YYYY-MM-DD");
  }

  if (queryParams.get("show_all_event_passes")) {
    filterByShowEndDate = "2018-01-01";
  }

  return filterByShowEndDate;
};

export const getShowData = createAsyncThunk("showData", async (farm: string) => {
  const cachedHorseData = getShowDataFromLocalStorage(farm);
  if (cachedHorseData) return cachedHorseData;

  return request.getJson(endpointMaker.api.showsByFarm(farm), true, null);
});
export const getAllShowsData = createAsyncThunk("allShowsData", async (farm: string) => {
  const cachedHorseData = getShowDataFromLocalStorage(farm);
  if (cachedHorseData) return cachedHorseData;
  const filterByShowEndDate = await getFilterByShowEndDate();

  return request.getJson(
    `${endpointMaker.api.showsAvailable(farm)}&filterByShowEndDate=${filterByShowEndDate}`,
    true,
    null
  );
});

export const getAllShowsDataV2 = createAsyncThunk("allShowsDataV2", async (farm: string) => {
  const cachedHorseData = getShowDataFromLocalStorage(farm);
  if (cachedHorseData) return cachedHorseData;
  const filterByShowEndDate = await getFilterByShowEndDate();

  return request.getJson(
    `${endpointMaker.api.getShows(farm)}&filterByShowEndDate=${filterByShowEndDate}`,
    true,
    null
  );
});

export const getShowList = createAsyncThunk("showList", async (farm: string) => {
  const cachedHorseData = getShowListFromLocalStorage(farm);
  if (cachedHorseData) return cachedHorseData;

  return request.getJson(endpointMaker.api.showsByFarm(farm), true, null);
});

export const getUserRecordForEqToken = createAsyncThunk("userInfo", async (token: string) => {
  return request.getJson(endpointMaker.api.userFromToken(token), true, null);
});

export const getUserInfo = createAsyncThunk("userInfo", async (farm: string) => {
  const cachedUserInfo = getUserInfoFromLocalStorage(farm);
  if (cachedUserInfo) return cachedUserInfo;

  return request.getJson(endpointMaker.api.userInfo(farm), true, null);
});

export const getEventPassListData = createAsyncThunk("eventPassList", async (farm: string) => {
  const filterByShowEndDate = await getFilterByShowEndDate();

  return request.getJson(
    `${endpointMaker.api.eventPassesByFarm(farm)}&filterByShowEndDate=${filterByShowEndDate}`,
    true,
    null
  );
});

export const getEventPassData = createAsyncThunk("eventPassData", async (eventId: string) => {
  const cachedHorseData = getShowsFromLocalStorage(eventId);
  if (cachedHorseData) return cachedHorseData;

  return request.getJson(
    endpointMaker.api.eventPassData(eventId, localStorage.getItem("farm")),
    true,
    null
  );
});

export const getEventDataByShow = createAsyncThunk(
  "eventPassDataByShow",
  async (eventId: string) => {
    const cachedHorseData = getEventPassDataByShowFromLocalStorage(eventId);
    if (cachedHorseData) return cachedHorseData;

    return request.getJson(
      endpointMaker.api.eventPassDataByShow(eventId, localStorage.getItem("farm")),
      true,
      null
    );
  }
);

export const getHealthDeclarationRequirement = createAsyncThunk(
  "getHealthDeclarationRequirement",
  async (eventId: string) => {
    const cachedHorseData = getShowsFromLocalStorage(eventId);
    if (cachedHorseData) return cachedHorseData;

    return request.getJson(
      endpointMaker.api.healthDeclarationRequirement(eventId, localStorage.getItem("farm")),
      true,
      null
    );
  }
);
